import axios from 'axios';
export class TrendsApi {
    apiBaseUrl;
    axios;
    static TRENDS_BASE_PATH = '/patient/trends';
    TRENDS_BASE_URL;
    constructor(apiBaseUrl, axios) {
        this.apiBaseUrl = apiBaseUrl;
        this.axios = axios;
        this.TRENDS_BASE_URL = `${apiBaseUrl}${TrendsApi.TRENDS_BASE_PATH}`;
    }
    static create = (apiBaseUrl, axiosInstance) => {
        if (!axiosInstance) {
            axiosInstance = axios.create();
        }
        return new TrendsApi(apiBaseUrl, axiosInstance);
    };
    getTrends = async (healthCategory) => {
        return this.axios.get(`${this.TRENDS_BASE_URL}/json?hc=${healthCategory}`);
    };
}
